import { useApi } from '@/api'

export const useProfileResource = () => {
  const api = useApi()

  return {
    getProfile: () => api.api.v1.me.get()
  }
}
